import React from "react";
import Header from "../../Layout/Header";
import Form from "../../components/Form";
import Footer from "../../Layout/Footer";
import { Container, Box } from "@mui/material";

import homeImg from "@assets/images/Corvell_svg_banner.svg";

const Home = () => {
  return (
    <>
      <Header />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: { xs: 4, sm: 4 },
          mb: { xs: 2, sm: 3 },
        }}
      >
        <Box
          component="img"
          src={homeImg}
          alt="Welcome"
          sx={{
            width: { xs: "90vw", sm: "90vh", md: "90vh" },
            maxWidth: "100%",
            height: { xs: "auto", sm: "auto", md: "auto" },
            maxHeight: "auto",
            objectFit: "contain",
            borderRadius: { xs: 2, sm: 3 },
            boxShadow: {
              xs: "0 2px 8px #1d72b811",
              sm: "0 4px 18px #1d72b820",
            },
            background: "#fafdff",
          }}
        />
      </Box>
      <Container
        maxWidth="sm"
        sx={{ px: { xs: 1, sm: 3 }, mb: { xs: 3, sm: 4 } }}
      >
        <Form />
      </Container>
      <Footer />
    </>
  );
};

export default Home;
